
import { Vue, Component, Prop } from 'vue-property-decorator';
import UiButton from '@/components/button/ui-button.vue';

import subscriptionPresentationDetails from '@/data/subscriptionPresentationDetails';

import { SubscriptionStatus } from '@/entities/payment/SubscriptionStatus';

import { Company, User } from '@/generated/graphql';

@Component({
	components: {
		UiButton,
	},
})
export default class SubsPlan extends Vue {
	@Prop({ type: Object, required: true }) readonly company!: Company;
	@Prop({ type: Object, required: true }) readonly currentUser!: User;
	@Prop({ type: Object, required: true }) readonly subcription: any;

	get isTrialPeriod(): boolean {
		return (
			this.company.subscriptions[0]?.status === SubscriptionStatus.TRIALING
		);
	}
	get isalreadyPremium(): boolean {
		const currentplanName = this.subcription?.subscription_plan?.inner_name;
		if( (currentplanName.includes("PREMIUM") ||
          currentplanName.includes("ENTERPRISE"))) return true;
		// if(this.subcription?.subscription_plan?.inner_name === 'PREMIUMPLUSFIFTY') return true;
		return false;
	}
	get getCancelAt(): boolean {
		return this.subcription?.cancel_at_period_end;
	}
	get getSlogan(): string {
		const packageName =
			this.subcription?.subscription_plan?.inner_name === 'STARTER'
				? 'STARTER'
				: this.subcription?.subscription_plan?.inner_name === 'GROWTH'
				? 'GROWTH'
				: 'PREMIUM';
		return subscriptionPresentationDetails[packageName]?.slogan;
	}

	get subscriptionPlan(): string {
		return this.subcription?.subscription_plan?.name === 'Starter' ||
			this.subcription?.subscription_plan?.name === 'Growth'
			? this.subcription?.subscription_plan?.name
			: 'Premium';
	}
	  get showTrialSection(): boolean {
    	return (this.isTrialPeriod && this.getCancelAt) || !this.subcription;
  }
  get freeTrialExpiry(): string {
    if (this.isTrialPeriod && this.subcription) {
        const periodEndTime = this.subcription.current_period_end; 
        const formattedEndDate = new Date(periodEndTime * 1000);

        const startDate = new Date(this.subcription.created_at); 

        // Format dates into localized date strings
        const formattedEndDateStr = formattedEndDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        const formattedStartDateStr = startDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });

        const differenceMs = formattedEndDate.getTime() - startDate.getTime();

        const differenceDays = differenceMs / (1000 * 60 * 60 * 24);

        return differenceDays <= 7 ? `${Math.floor(differenceDays)} days left for Free Trial.` : 'Trial expired, please upgrade your subscription';
    }

    return ''; 
}


	created() {}
}
